import { type FC, type TouchEventHandler, type UIEvent, useRef } from 'react';
import cn from 'classnames';
import { motion } from 'framer-motion';

import { StartLotteryDrawAnimation } from '@/components/Animations/StartLotteryDrawAnimation/StartLotteryDrawAnimation';

import { LotteryRewardContent } from '../LotteryRewardsContent/LotteryRewardContent';
import { type LotteryRewardsAnimationsRef } from '../model';

import { Background } from './Background/Background';
import { ImagesSwiper } from './ImagesSwiper/ImagesSwiper';
import { SideEffects } from './SideEffects/SideEffects';

import css from './styles.module.scss';

const LotteryContainer: FC = () => {
  const contentRef = useRef<HTMLDivElement>(null);
  const animationsRef = useRef<LotteryRewardsAnimationsRef | null>(null);
  const startYTochRef = useRef<number>(0);
  const currentPositonRef = useRef<'top' | 'bottom'>('top');

  const calcMaxScrollValue = (event: UIEvent<HTMLDivElement>): number => {
    const element = event.currentTarget;
    const wrapperHeight = element.getBoundingClientRect().height;
    const contentHeight = contentRef.current?.getBoundingClientRect().height;

    if (wrapperHeight && contentHeight) {
      return Math.floor(contentHeight - wrapperHeight);
    } else {
      return 0;
    }
  };

  const onTouchStart: TouchEventHandler<HTMLDivElement> = (event) => {
    const touch = event.touches[0];

    if (touch) {
      startYTochRef.current = touch.clientY;
    }
  };

  // const onTouchMove: TouchEventHandler<HTMLDivElement> = (event) => {
  //   const touches = Array.from(event.touches);
  //   const touch = touches[0];
  //   const maxScrollValue = calcMaxScrollValue(event);
  //   const currentTouchY = touch.clientY;
  //   const moveY = currentTouchY - touchRef.current.startY;
  //   console.log(`move: ${moveY}`);
  //   if (moveY < 0 && currentPositonRef.current === 'top') {
  //     animateTitle(moveY, maxScrollValue);
  //   }
  //   if (moveY > 0 && currentPositonRef.current === 'bottom') {
  //     animateTitle(maxScrollValue + moveY, maxScrollValue);
  //   }
  //   touches.forEach((touch) => {
  //   });
  // };

  const onTouchEnd: TouchEventHandler<HTMLDivElement> = (event) => {
    console.log(event);
    const touch = event.changedTouches[0];

    if (touch) {
      const currentTouchY = touch.clientY;
      const endY = currentTouchY - startYTochRef.current;
      const maxScrollValue = calcMaxScrollValue(event);

      if (endY < 0 && currentPositonRef.current === 'top') {
        animationsRef.current?.animateAll(maxScrollValue, maxScrollValue);
        currentPositonRef.current = 'bottom';
      }

      if (endY > 0 && currentPositonRef.current === 'bottom') {
        animationsRef.current?.animateAll(0, maxScrollValue);
        currentPositonRef.current = 'top';
      }
    }
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.4 }}
      onTouchStart={onTouchStart}
      onTouchEnd={onTouchEnd}
      className={cn(css.lotteryContainer, 'hidden-scrollbar')}
    >
      <div ref={contentRef} className="flex flex-col items-center relative">
        <div className={css.snapPoint}></div>
        <Background />
        <ImagesSwiper />
        <SideEffects />
        <LotteryRewardContent ref={animationsRef} />

        <div className={css.snapPoint}></div>
      </div>
      <StartLotteryDrawAnimation />
    </motion.div>
  );
};

export { LotteryContainer };
